angular.module('impactx.catalog').controller('VCatalogViewImportCtrl', [
    '$scope',
    'dataGen',
    'ToastService',
    '$mdDialog',
    'TranslationService',
    'trns',
    'vCatId',
    VCatalogViewImportCtrl
]);

function VCatalogViewImportCtrl($scope, dataGen, ToastService, $mdDialog, TranslationService, trns, vCatId) {
    var ctrl = this;

    $scope.uploadExcel = {};
    $scope.trns = trns;

    ctrl.import = function (event) {
        $scope.uploadInProgress = true;
        var paramObj = {
            vCatId: vCatId,
            file: $scope.uploadExcel.file
        };
        dataGen.uploadFile(paramObj, '/vcatalog/importview', true).then(function () {
            $scope.uploadInProgress = false;
            $mdDialog.hide();
            ToastService.openStandardToast(TranslationService.get('saveSuccess'));
        }, function () {
            $scope.uploadInProgress = false;
        });
    };

    ctrl.cancel = function () {
        $mdDialog.cancel();
    }

}